module.exports = __webpack_public_path__ + "img/logo_contest_brochure_head.30c5d2dc.jpg";